/**
 * Parse the filename from a `Content-Disposition` header. Prefers the RFC 5987
 * `filename*=UTF-8''<percent-encoded>` parameter (which preserves Unicode) and
 * falls back to the legacy `filename="..."` parameter for older clients.
 */
export function parseContentDispositionFilename(header: string | undefined): string | undefined {
	if (!header) return undefined;

	const extendedMatch = /filename\*=(?:UTF-8|utf-8)'[^']*'([^;\s]+)/i.exec(header);

	if (extendedMatch) {
		try {
			return decodeURIComponent(extendedMatch[1]);
		} catch {
			// Malformed percent-encoding — fall through to the legacy param.
		}
	}

	return /filename="([^"]*)"/.exec(header)?.[1];
}
